import { createContext } from "react";

const AuthContext = createContext<any | undefined>(undefined);

export default AuthContext;
